var EqServerQueryStorage = /** @class */ (function () {
    function EqServerQueryStorage(context) {
        this.context = context;
    }
    EqServerQueryStorage.prototype.init = function () {
    };
    EqServerQueryStorage.prototype.newQuery = function (options) {
        options = options || {};
        var query = options.query || this.context.getQuery();
        var model = this.context.getModel();
        var modelId = options.modelId || (model ? model.getId() : "");
        if (options.queryId) {
            query.setId(options.queryId);
        }
        if (options.name) {
            query.setName(options.name);
        }
        if (options.description) {
            query.setDescription(options.description);
        }
        var requestData = {
            'query': query.toJSONData()
        };
        if (options.data) {
            requestData['data'] = options.data;
        }
        var url = this.context.resolveEndpoint('NewQuery', { modelId: modelId });
        var http = this.context.getServices().getHttpClient();
        return http.post(url, requestData)
            .then(function (responseData) {
            return responseData.query;
        });
    };
    EqServerQueryStorage.prototype.getQueryList = function (options) {
        options = options || {};
        var modelId = options.modelId || this.context.getModel().getId();
        var url = this.context.resolveEndpoint('GetQueryList', { modelId: modelId });
        var http = this.context.getServices().getHttpClient();
        return http.get(url)
            .then(function (responseData) {
            if (!responseData.queries) {
                return Promise.reject({
                    message: 'Wrong response format'
                });
            }
            return responseData.queries;
        });
    };
    EqServerQueryStorage.prototype.loadQuery = function (options) {
        options = options || {};
        var model = this.context.getModel();
        var query = this.context.getQuery();
        var modelId = options.modelId || model.getId();
        var queryId = options.queryId || query.getId();
        var url = this.context.resolveEndpoint('GetQuery', { modelId: modelId, queryId: queryId });
        var http = this.context.getServices().getHttpClient();
        return http.get(url)
            .then(function (responseData) {
            return responseData.query;
        });
    };
    EqServerQueryStorage.prototype.saveQuery = function (options) {
        options = options || {};
        var query = options.query || this.context.getQuery();
        var queryId = options.queryId || query.getId();
        if (options.queryId) {
            query.setId(options.queryId);
        }
        var modelId = options.modelId || query.getModel().getId();
        if (options.queryId) {
            query.setId(options.queryId);
        }
        var requestData = {
            'query': query.toJSONData()
        };
        if (options.data) {
            requestData['data'] = options.data;
        }
        var url = this.context.resolveEndpoint('SaveQuery', { modelId: modelId, queryId: queryId });
        var http = this.context.getServices().getHttpClient();
        return http.put(url, requestData)
            .then(function (responseData) {
            return responseData.query;
        });
    };
    EqServerQueryStorage.prototype.removeQuery = function (options) {
        options = options || {};
        var context = this.context;
        var query = context.getQuery();
        var modelId = options.modelId || query.getModel().getId();
        var queryId = options.queryId || query.getId();
        var requestData = {
            'modelId': modelId,
            'queryId': queryId
        };
        if (options.data) {
            requestData['data'] = options.data;
        }
        var url = this.context.resolveEndpoint('RemoveQuery', { modelId: modelId, queryId: queryId });
        var http = this.context.getServices().getHttpClient();
        return http.delete(url, requestData).getPromise();
    };
    return EqServerQueryStorage;
}());
export { EqServerQueryStorage };
//# sourceMappingURL=eqs_query_storage.js.map